import {DefaultFileHandler, FileHandler} from './FileHandler';
import {FileData} from "./FileData";
import plupload from 'plupload';

class VideoFileHandler extends DefaultFileHandler implements FileHandler {

    handleError(up: plupload.Uploader, error: plupload_error): void {
        let response;
        if (error.response) {
            try {
                response = JSON.parse(error.response).message;
            } catch (e) {
                response = "An error occurred while uploading this file.";
            }
        } else {
            response = error.message;
        }

        const data = this.fileData[error.file.id];

        this.store.dispatch('videos/setError', {
            id: data.video_id,
            key: 'local_source_file_status',
            value: response
        });

        this.store.dispatch('videos/setUploadProgress', {
            id: data.video_id,
            progress: 0,
        });
    }

    handleBeforeUpload(up: plupload.Uploader, file: any): void {}

    handleBeforeChunkUpload(up: plupload.Uploader, file: any, info: any): void {}

    handleChunkUploaded(up: plupload.Uploader, file: any, info: any): void {}

    handleFileUploaded(up: plupload.Uploader, file: any): void {
        const fData = this.fileData[file.id];
        this.store.dispatch('videos/setUploadProgress', {
            id: fData.video_id,
            progress: 100,
        });
        this.store.dispatch('videos/syncSourceStatusUntilComplete', fData.video_id);
    }

    handleFilesAdded(up: plupload.Uploader, file: any): void {
        const data = this.fileData[file.id];
        this.store.dispatch('videos/clearError', {
            id: data.video_id,
            key: 'source_file_status'
        });
    }

    handleUploadProgess(up: plupload.Uploader, file: any): void {
        this.store.dispatch('videos/setUploadProgress', {
            id: this.fileData[file.id].video_id,
            progress: file.percent,
        });

        if (file.percent === 100) {
            this.store.dispatch('videos/update', {
                local: true,
                key: 'source_file_status',
                value: 'pending',
                id: this.fileData[file.id].video_id,
            });
        }
    }

    isFileOfType(file: any, data: FileData): boolean {
        return data.upload_type === 'video';
    }

    handlePaused(up: plupload.Uploader, current: plupload.File): void {
        const data = this.fileData[current.id];
        this.store.dispatch('videos/update', {
            id: data.video_id,
            key: 'source_file_status',
            value: 'upload_paused',
            local: true,
        });
    }

    handleResume(up: plupload.Uploader, current: plupload.File): void {
        const data = this.fileData[current.id];
        this.store.dispatch('videos/update', {
            id: data.video_id,
            key: 'source_file_status',
            value: 'uploading',
            local: true,
        });
    }
}

export default VideoFileHandler;
